<template>
  <div class="linechartSelectedLabels">
    <ul class="labels">
      <li class="labels__item" v-for="attr in data">
        <span class="labels__item__color">
          <svg width="8px" height="9px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 10 10">
            <circle :class="['svg-fill--' + attr.color]" class="cls-3" cx="5" cy="5" r="5"/>
          </svg>
        </span>
        <span class="labels__item__name" :class="['color--' + attr.color]">{{ attr.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LineChartSelectedLabels',
  props: ['data']
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .labels{
    display: flex; -js-display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0 0 0 -15px;
    padding: 0;
    position: relative;
    z-index: 1;
  }
  .labels__item{
    margin: 0;
    padding: 3px 15px 0;
  }
  .labels__item__color{
    display: inline-block;
    margin-right: 5px;
  }
  .labels__item__name{ font-weight: 600; }

</style>



// WEBPACK FOOTER //
// src/components/shared/charts/LinechartSelectedLabels.vue